<table class="table table-docs">
  <thead>
    <tr>
      <th>Sl. No.</th>
      <th>Name</th>
      <th class="center">Questions Answered</th>
      <th class="center">High Risks</th>
      <th class="center">Medium Risks</th>
    </tr>
  </thead>
  <tbody *ngIf="lenses?.length > 0">
    <tr *ngFor="let lens of lenses; let i = index">
      <td>{{ i + 1 }}</td>
      <td>
        <span class="nav-link cursor-pointer p-0" (click)="onOpenLens(lens)">
          {{ lens.lens_name }}
        </span>
      </td>
      <td class="center">{{ lens.answered_label }}</td>
      <td class="center">{{ lens.high_risk_count }}</td>
      <td class="center">{{ lens.medium_risk_count }}</td>
    </tr>
  </tbody>
  <tbody *ngIf="lenses?.length === 0">
    <tr>
      <td colspan="5" class="center">No lenses found</td>
    </tr>
  </tbody>
</table>
